import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lms-clients-settings',
  templateUrl: './clients-settings.component.html',
  styleUrls: ['./clients-settings.component.scss']
})
export class ClientsSettingsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
